module.exports = __webpack_public_path__ + "img/6.3114b088.jpg";